/**
* Quando o status está indefinido.
*/
const UNDEFINED = 1;

/**
* Quando o status da ativo está em atenção.
*/
const ALARM = 2;

/**
* Quando o status da ativo está em atenção.
*/
const TRIP = 3;

export default {
	UNDEFINED,
	ALARM,
	TRIP,
};